import { Tag } from "antd";
import t from "../../../app/i18n";
import { PresetColors } from "../../constants";

interface Props {
  style?: React.CSSProperties;
}

const DeactivatedTag = ({ style }: Props) => (
  <Tag color={PresetColors.RED}>
    <span style={{ textTransform: "capitalize", ...style }}>{t("common.deactivated")}</span>
  </Tag>
);

export default DeactivatedTag;
